import sum from 'lodash/sum';

import {
  Experiment,
  ExperimentMetric,
  ExperimentMetricLifts,
  ExperimentStatus,
  ExperimentVariant,
  ExperimentVariantLifts,
} from 'apps/experiments/src/types';

export const NEW_EXPERIMENT_PARAMS = {
  name: `New Experiment`,
  settings: {},
};
export const DEFAULT_CONTROL_KEY = `Control`;
export const DEFAULT_CONFIDENCE_LEVEL = 0.95;
export const DEFAULT_SAMPLE_SIZE = 10000;
export const MIN_CONFIDENCE_LEVEL = 0.8;
export const MAX_CONFIDENCE_LEVEL = 0.9999;
export const MIN_SAMPLE_SIZE = 0;
export const MAX_SAMPLE_SIZE = 100000;

export function computeStatusPercent(experiment: Experiment) {
  if (experiment.status !== ExperimentStatus.ACTIVE) {
    return undefined;
  }

  if (!experiment.settings.sampleSize) {
    return 1;
  }
  const count = sum(Object.values(experiment.exposures_cache));

  return count / experiment.settings.sampleSize;
}

export function computeAverageLift(metrics: ExperimentMetric[], liftsMap: ExperimentMetricLifts) {
  if (!metrics.length) {
    return undefined;
  }
  return (
    metrics.reduce((acc, metric) => {
      const lift = liftsMap[metric.id] ?? 0;
      return acc + lift;
    }, 0) / metrics.length
  );
}

export function computeAverageLiftForVariant(
  variant: ExperimentVariant,
  metrics: ExperimentMetric[],
  liftsMap: ExperimentVariantLifts,
) {
  const variantLiftsMap = liftsMap[variant.id];
  if (!variantLiftsMap) {
    return undefined;
  }
  return computeAverageLift(metrics, variantLiftsMap);
}

export function computeAverageLiftsForPrimaryMetrics(experiment: Experiment) {
  switch (experiment.status) {
    case ExperimentStatus.DRAFT:
      return undefined;
    case ExperimentStatus.ACTIVE:
      return undefined;
    default:
    // continue
  }

  if (!experiment.variants.length) {
    return undefined;
  }

  const primaryMetrics = experiment.metrics?.filter((metric) => metric.type === `primary`) ?? [];
  if (!primaryMetrics.length) {
    return undefined;
  }

  return experiment.variants?.map((variant) => ({
    variant,
    lift: computeAverageLiftForVariant(variant, primaryMetrics, experiment.results_cache.lifts),
  }));
}
